import {Search} from "./search";
const ctx: Worker = self as any;
const search = new Search(ctx);